export default {
  courseLevelCount: 'Course level/batch',
  errorAnalysisRequireLabel: 'Error analysis required',
  learnErrorCount: 'Learned error count',
  markedErrorCount: 'Marked error count',
  errorMarkRate: 'Error mark rate',
  totalQuestionCount: 'Total questions',
  readCircleCount: 'Read circle count',
  readCircleRate: 'Read circle rate',
  readCircleRightRate: 'Read circle correct rate',
  noReadCircleRightRate: 'No-read circle correct rate',
  invalidReadCircleCount: 'Invalid read circle count',
  validReadCircleRate: 'Valid read circle rate',

  chapterTaskCard: 'Chapter task card',
  account: 'Account',
  accountBalance: 'Account balance',
  accountDisabledTip: 'This account has been disabled due to [{reason}]. Disabled by: [{source}]. If you have objections, please contact the disabling party for details.',
  accountModifyRecord: 'Account modify record',
  accountPassword: 'Account Password',
  accountRoleName: 'Account Role',
  accountSearch: 'Account Search:',
  accountSecurityTip: 'For account security, please enter your password first',
    accountSet: 'Account Management',
  accountStatus: 'Account Status',
  accountStatusLabel: 'Account Status',
  accountStatusPlaceholder: 'Account status',
  accountTypeLabel: 'Account Type',
  accumulatedAbnormal: 'Accumulated abnormal',
  activateMonth: 'Software Activate Month',
  activateStatus: 'Software Activate Status',
  activateTime: 'Software Activate Time',
  active: 'Active',
    add: 'Add',
    addAccount: 'Add Account',
  addAccountFailed: 'Failed to add account',
  addAccountSuccess: 'Account added successfully',
  addAccountSuccessMsg: 'Account added successfully',
  addAction: 'Add',
  addAnalyst: 'Add Analyst',
  addCustomRole: 'Add Custom Role',
  addEmployee: 'Add Employee',
  addEmployeeTip: 'After adding employee account, the employee will receive a DingTalk invitation. Log in to DingTalk to join.',
  addFaceInfo: 'Add Face Info',
  addFailed: 'Add failed',
  addInfoSuccess: 'Add info successful',
  addSchoolFail: 'Add school failed',
  addSchoolSuccess: 'Add school successful',
  addStudent: 'Add Student',
  addStudentArchiveTip: '(Note: Users with incomplete profiles are excluded. Please complete the profile first to add.)',
  addSuccess: 'Added successfully',
  agent: 'Agent ID',
  agentId: 'Agent ID',
  agentLabel: 'Agent',
  agentName: 'Agent Name',
    agentNo: 'Agent No.',
    agentNoLabel: 'Agent No.:',
    agentNoPlaceholder: 'Agent No.',
  agentTypeLabel: 'Agent Type',
  all: 'All',
  already: 'Used Quota',
  amount: 'Voucher Redemption Amount',
  analysisSystemAccountStatus: 'Analysis System Account Status',
  analyst: 'Analyst:',
  analystAccountStatus: 'Analyst Account Status',
  analystAddStudents: 'Analyst {name} - Add Students',
  analystName: 'Analyst Name',
  analystNamePlaceholder: 'Analyst name/phone',
  answerFast: 'Answer Fast',
  answerSlow: 'Answer Slow',
  applyAccount: 'Apply Account',
  experienceApplyConfirmTip: 'After submission, {name} will be granted an employee learning account. Please make sure the employee uses it properly. Continue?',
  applyAnalystConfirm: 'Confirm to apply analyst identity for the following employee?',
  applyAnalystRole: 'Apply Analyst Role',
  applyAnalystTitle: 'Apply Analyst Identity',
  applying: 'Applying',
  approved: 'Approved',
  asset: 'Asset',
  assignPermissions: 'Assign Permissions',
  audioParseError: 'Audio parse error, please re-upload',
  audit: 'Review Comment',
  authorityDetails: 'Assign Permissions',
  autumnTerm: 'Autumn',
  back: 'Back',
  bai: 'Hundreds',
  batchAddFailed: 'Batch add failed',
  batchAddStudent: 'Batch Add Students',
  batchAddSuccess: 'Batch added successfully',
  batchCancelAssignFail: 'Batch cancel assign failed',
  batchCancelAssignSuccess: 'Batch cancel assign successful',
  batchRemoveFailed: 'Batch remove failed',
  batchRemoveStudent: 'Batch Remove Students',
  batchRemoveSuccess: 'Batch removed successfully',
  beforeLastMonthHighActiveRate: 'Before Last Month High Active Rate',
  bindMobile: 'Bind Mobile',
  bindMobileSuccess: 'Bind mobile successful!',
  bonusGranted: 'Bonus Granted',
  buyNum: 'Purchase Qty',
  callSystem: 'Call System',
  callTime: 'Call Time',
    cancel: 'Cancel',
  cancelInvite: 'Cancel invite',
  channelAgentName: 'Channel Agent Name',
  checkAddTip: 'Select students to add',
  checkRemoveTip: 'Select students to remove',
  chineseBaseDuration: 'Chinese foundation, total duration',
  chineseBaseProgress: 'Chinese foundation, max progress',
  chuangjian: 'Creator',
  ci: 'Times',
  city: 'City',
  claimInternalAccount: 'Claim Internal Experience Account',
  claimTime: 'Claim Time',
  claimUser: 'Claim User',
  clearFilter: 'Clear Filter',
  clickToSelect: 'Click to Select',
  collapse: 'Collapse',
  completePaymentTime: 'Complete Payment Time',
  completed: 'Completed',
  completionStatus: 'Completion',
    confirm: 'Confirm',
    confirmAndConfigPermission: 'Confirm & Configure Permissions',
  confirmDeleteCustomIdentity: 'Confirm to delete this custom identity?',
  confirmResetPassword: 'Confirm reset password?',
  consecutiveError: 'Consecutive Error',
  contractPaidAmount: 'Contract Paid Amount',
  copy: 'Copy',
  copySuccess: 'Copied successfully',
  course: 'Course',
  courseLevelTimes: 'Course level/times',
  createSuccess: 'Created successfully',
  createTime: 'Create Time',
  createTimeLabel: 'Create Time',
  currentSupervisor: 'Current Supervisor',
  customIdentityDesc: 'Custom identity description:',
  customIdentityName: 'Custom identity name:',
  customRole: 'Custom Role',
  customer: 'Please select the referral customer ID',
  customerName: 'Customer name/phone',
  customerPhone: 'Customer Phone',
  customerArea: 'Customer Region',
  dai: 'Referrer ID',
  daiji: 'Cumulative Channel Agent Level',
  dailyActivationTime: 'Daily Activation Time',
  dailyUpdateTip: 'Daily data updates previous day; Monday fixes last week',
  dataAnalysisPassword: 'Data Analysis System Password',
  dataAnalysisSystem: 'Data analysis service system',
  dataAnalysisUsername: 'Data Analysis System Username',
  dataPermissionConfig: 'Data permission config',
  dataPermissionDesc: 'Determines which data the employee can see',
  dataUpdateTime: 'Data Update Time:',
  dataUpdatedTo: 'Data updated to: ',
  date: 'Date',
  dateLabel: 'Date',
  dateRangeTo: 'to',
  day: 'undefined',
  dayci: 'Number of Consecutive Errors in a Single Day',
  dayhour: 'Daily Study Idle or Leave Duration Ratio',
  daze: 'Daze',
  dealer: 'Referral Dealer Renewal Reward Ratio',
  dealerPassword: 'Dealer System/Mini Program Password',
  dealerSystem: 'Dealer system',
  dealerSystemOnly: 'Dealer system only',
  dealerSystemPlusAnalysis: 'Dealer system + Analysis system',
  dealerSystemTip: 'To use dealer mini program, please check "Dealer system" first',
  dealerUsername: 'Dealer System/Mini Program Username',
  delete: 'Delete',
  deleteCustomIdentityTip: 'Deleting will not affect employees who have been assigned this identity.',
  deleteFailed: 'Delete failed',
  deleteInfoSuccess: 'Delete info successful',
  deleteRole: 'Delete Role',
  deleteSuccess: 'Deleted successfully',
  deliverOrderValueExport: 'Deliver Order Value Report Export',
  desc: 'Description',
  detail: 'Detail',
  deviceStatusActivated: 'Activated',
  deviceStatusFrozen: 'Frozen',
  deviceStatusLabel: 'Device Status',
  deviceStatusSubscribed: 'Subscribed',
  deviceStatusUnactivated: 'Unactivated',
  deviceUseStatus: 'Device Use Status',
  deviceUseTime: 'Device Use Time',
  dianhua: 'Introducer Phone',
  difficultyExplain: 'Difficulty level explanation',
  dimension: 'Dimension',
  dimensionHighActive: 'High Activity',
  dimensionRetention: '3-Month Retention',
  dimensionStudyAbnormal: 'Study Process Anomaly',
  dimensionStudyDuration: 'Study Duration',
  dimensionStudyTrace: 'Study Trace',
  disNo: 'Outbound Display Mobile',
  disNoPlaceholder: 'Outbound Display Mobile',
  disable: 'Disable',
  disableAccountConfirmTip: 'After account is disabled, {username}',
    disableConfirm: 'Disable account',
  disableSuccess: 'Disable successful',
  experienceDisableConfirmTip: 'After submission, the employee learning account of {name} will no longer be available on the learning device. Continue?',
    disableTip: 'After disabled, the account cannot log in or operate the dealer system',
    disabled: 'Disabled',
  dispatchMonth: 'Dispatch Month',
  dispatchNum: 'Dispatch Qty',
  dispatchQuantity: 'Dispatch Qty',
  dispatchTime: 'Dispatch Time',
  dispatchType: 'Dispatch Type',
  district: 'District',
  doubleOrder: 'Double Order',
  downloadDetailData: 'Download Detail Data',
  draftCorrectRate: 'Draft question correct rate',
  draftMarkRateLabel: 'Draft Trace Rate',
  draftPassRateLabel: 'Draft Pass Rate',
  draftQualifyHelp: 'How to judge draft writing quality?',
  draftRate: 'Draft step pass rate',
  draftStepPassRate: 'Draft Step Pass Rate',
  draftWriting: 'Draft Writing',
  draftWritingRate: 'Draft step writing rate',
  durationMin: 'Duration (min)',
  edit: 'Edit',
  editAccount: 'Edit Account',
  editAccountFailed: 'Edit account failed!',
  editAccountFailedMsg: 'Failed to edit account',
  editAccountSuccess: 'Account edited successfully',
    editFailed: 'Edit failed',
    editRole: 'Edit Role',
  editSchoolSuccess: 'Edit school successful',
  editSuccess: 'Edit successful',
  effectiveDuration: 'Effective Duration',
  effectiveFoundationTime: 'Effective Foundation Time',
  effectiveScoreCollectRate: 'Effective Score Collection Rate',
  effectiveScoreNum: 'Effective Score Students',
  effectiveScoreRate: 'Effective Score Rate',
  email: 'Email',
  emailOrMobileRequired: 'Email or mobile is required!',
  employeeAccount: 'Employee Account',
  employeeAccountStatus: 'Employee Account Status',
    employeeName: 'Employee name:',
  employeeRole: 'Employee Role',
  employeesAccount: 'Employee Accounts',
  enable: 'Enable',
  enableConfirm: 'Re-enable account',
  enableFailed: 'Failed to enable account',
  enableSuccess: 'Enable successful',
  enableSuccessMsg: 'Account enabled successfully',
  enableTip: 'After enabled, the account can log in and operate the dealer system normally',
  enabled: 'Enabled',
  englishBaseDuration: 'English foundation, total duration',
  englishBaseProgress: 'English foundation, max progress',
  entryAccount: 'Entry Account',
  equipmentValueExport: 'Equipment Value Report Export',
  er: 'Level 2',
  errorAnalysis: 'Error Analysis',
  errorAnalysisCompletion: 'Error analysis completion',
  evaluationScoreLabel: 'Evaluation Score',
  errorAnalysisHelp: 'How to do error analysis?',
  errorAnalysisRequired: 'Error analysis required for grade 1-6 foundation (first two times)',
  errorAnalyzeLabel: 'Error Analysis Rate',
  errorCount: 'Error Count',
  examScoreImprovementRate: 'Exam Score Improvement Rate',
  examType: 'Exam Type',
  examTypeLabel: 'Exam Type',
  exampleTrial: 'Example Trial',
  exampleTrialNorm: 'Example trial standard',
  exampleTrialRate: 'Example Trial Rate',
  exampleTrialTraceRate: 'Example trial trace rate',
  exceptionLevelLabel: ' Level Exception',
  expand: 'Expand',
  experienceAccount: 'Experience Account',
  experienceStudentCount: 'Experience Students',
  experiencesAccount: 'Employee Learning Accounts',
  exportReport: 'Export Report',
  expressCompany: 'Express Company',
  expressNo: 'Express No.',
  expressNoLabel: 'Dispatch No.',
  faceExistUploadCorrect: 'Face info already exists, please upload correct employee photo',
  faceInfoStatus: 'Face Info Status',
  faceInfoRiskTip: 'The employee learning account has enabled intelligent risk control. Face info must be uploaded before the account can be used.',
  faceInfoUpdatedRecentlyTip: 'This employee learning account face info was updated recently. Please try again after {time}.',
  faceInfoUpdateLimitTip: 'Employee learning accounts can only update face info once every two months. Last update time: {time}. Please proceed carefully.',
  faceInfoAgeConfirm: 'The photo does not appear to be an adult photo. Are you sure you want to use it?',
  faceInfoUploadFormatTip: 'Only JPG, JPEG, GIF, PNG, and BMP images are allowed.',
  facePhotoEncryptTip: '* Your uploaded photos will be encrypted and used for no other purpose',
  facePhotoSpec: 'Photo Specification:',
  facePhotoSpec1: 'Photo must be front-facing',
  facePhotoSpec2: 'Avoid wearing hats or accessories',
  facePhotoSpec3: 'Photo background should be white wall',
  female: 'Female',
    fillBasicInfo: 'Please fill in basic information',
  fillerLabel: 'Filler',
  finalExam: 'Final',
  finalPaymentTime: 'Final Payment Time',
  firstDispatchTime: 'First Dispatch Time',
  firstTime: 'First time',
  firstWeekFeedback: 'First Week Feedback',
  fixedPositionComponentTip: 'Fixed position components (e.g. bottom nav, float) cannot be placed first!',
  followLabel: 'Follow:',
  followingUp: 'Following up',
  formalStudentCount: 'Formal Students',
  freightAmount: 'Freight Amount',
  frontFacePhoto: 'Front Face Photo',
  frozen: 'Frozen',
  fullProcessTraining: 'Full Process Training',
  fulltime: 'Full-time',
    functionPermissionConfig: 'Function permission config',
    functionPermissionDesc: 'Determines which functions the employee can see',
  gender: 'Gender',
  getDataFailed: 'Failed to get data',
  getDataFailedExclaim: 'Failed to get data!',
  getVerifyCode: 'Get verification code',
    goldCoin: 'Gold coins',
    goldCoinUnit: ' gold coins',
  grade: 'Stage/Grade',
    handover: 'Handover',
  handoverPerson: 'Handover person',
  handoverRecord: 'Handover record',
  hantianCallSystem: 'Hantian Call System',
  hardStatus: 'Hardware Activate Status',
  hardTime: 'Hardware Activate Time',
  hardwareActivateTime: 'Hardware Activate Time',
  healthExplain: 'Health level explanation',
  healthUpDownExplain: 'Health Level Explanation',
  highActive: 'High Active',
  highestRatio: 'Highest ratio',
  hour: 'h',
  hourhour: 'Answering Duration Exceeds Average Duration',
  houryici: 'Use previous params',
  howScoreCalculated: 'How is the score calculated?',
  iKnow: 'Got it',
  id: 'Referrer ID',
  imageFormatJpgPngOnly: 'Only JPG, JPEG, PNG format images allowed',
  imagePositionRequired: 'Image position cannot be empty. Please upload image or remove component',
  imageSizeExceed5M: 'File size exceeds 5M limit~',
  improvedScoreNum: 'Improved Score Students',
  info: 'Missing Information',
  infoMissing: 'Info Missing',
  initialPassword: 'Initial Password',
  initialPasswordLabel: 'Initial Password',
  instinctExplain: 'Instinct Level Explanation',
  internalAccountTip1: 'Internal experience account must be bound to employee Squirrel AI account',
  internalAccountTip2: 'Only employees with "Normal" status can claim internal experience account',
  introducerOrChannelAgentId: 'Introducer/Channel Agent ID',
  invalidMobileFormat: 'Invalid mobile number format',
  investorRoleCannotModify: 'Main account investor role cannot be modified',
  isFirstReward: 'First Time?',
  ji: 'Cumulative Channel Level',
  jidao: 'Upgrade to',
  jie: 'Frozen',
  jinzhanghu: 'Gold Account',
  knowledgeNote: 'Knowledge Note',
  lastMonthHighActiveRate: 'Last Month High Active Rate',
  leads: ' leads',
  learnTimeLabel: 'Study Duration',
  learningAccountStatus: 'Learning Account Status',
    leaveDateLabel: 'Leave Date',
  leaveMidway: 'Leave Midway',
    leaveTimeLabel: 'Leave Time',
  level: 'level',
  levelOne: 'Level 1',
  levelTwo: 'Level 2',
  levelThree: 'Level 3',
  levelFour: 'Level 4',
  levelFive: 'Level 5',
  levelSix: 'Level 6',
  levelSeven: 'Level 7',
  levelEight: 'Level 8',
  levelNine: 'Level 9',
  levelTen: 'Level 10',
  listenRecording: 'Listen Recording',
  loginPassword: 'Login password:',
  mainSystem: 'Main system: ',
  male: 'Male',
  markSupervisorInfo: 'Mark Supervisor Info',
  mathBaseDuration: 'Math foundation, total duration',
  mathBaseProgress: 'Math foundation, max progress',
  messageExport: 'Message Export',
  messageReadUserCount: 'Read Count',
  messageSendDate: 'Send Date',
  messageSendUserCount: 'Recipients',
  midtermExam: 'Midterm',
  min: 'Error Analysis',
  minhour: 'When paginating',
  mobile: 'Mobile',
  mobileModifyTip: 'Note: To modify employee login mobile number, please ask the employee to log in and go to Account Security Center to modify.',
  mobileModifyTip2: 'Note: To modify employee mobile number, please ask the employee to log in and go to Account Security Center after account activation',
  modifyAnalyst: 'Edit Analyst',
  modifyInfoSuccess: 'Modify info successful',
  modifyRecord: 'Modify record',
  modifySuccess: 'Modified successfully',
  month: 'Month',
  monthDataLabel: 'Monthly Data',
    monthActive: 'Monthly Active',
  more: 'More',
  msgDesc: 'Description',
  msgTitle: 'Title',
  name: 'Name',
  nameLabel: 'Name:',
  namePlaceholder: 'Name',
  nameRequired: 'Name is required',
  newOrderNo: 'Latest Purchase Order No.',
  newStudentName: 'New Student Name',
  newStudentNameOrPhone: 'New Student Name or Phone',
  newStudentPeriod: 'New Student Period',
    newSupervisorNum: 'New Supervisor Students',
    newSupervisorNumTip: 'Students newly marked as study room or online-only this month',
  nineMonthRetentionRate: '9-Month Retention Rate',
    nineMonths: '9 Months',
  noCollectNum: 'Students with No Score Collected',
  noDraftCorrectRate: 'Non-draft question correct rate',
  noExceptionThisWeek: 'No exceptions this week!',
    noQualifiedStudents: 'No qualified students',
  noRecording: 'No Recording',
  noSupervisorActiveNum: 'No Supervisor Active Students',
  noSupervisorNum: 'No Supervisor Students',
  noSupervisorNumTip: 'No supervisor: not marked, or supervisor status expired',
  normal: 'Normal',
  notApplied: 'Not Applied',
  notCompleted: 'Not Completed',
  num: 'Shipment Quantity',
    onlineOnlyNum: 'Online-only Students',
  onlyOneComponentTip: 'Only one such component can be added!',
  opDesc: 'Operation description',
  opTime: 'Operation time',
  opType: 'Operation type',
  opUser: 'Operator',
  opUserLabel: 'Operator',
  operation: 'Operation',
  optional: 'Optional',
  order: 'Credit Order Shipped Unpaid Fission Amount',
  orderAmount: 'Order Amount',
  orderCreateTime: 'Order Create Time',
  orderNo: 'Order No.',
  orderQuantity: 'Order Qty',
  orderStatus: 'Order Status',
  orderStatusLabel: 'Order Status',
  orderTime: 'Order Time',
  orderType: 'Order Type',
  outerDisplayMobile: 'Outbound Display Mobile:',
  pagePermissionConfig: 'Page permission config',
  pagePermissionDesc: 'Determines which pages the employee can see',
  paidAmount: 'Paid Amount',
  password: 'Password',
  passwordResetSuccess: 'Password has been reset to songguo123',
  passwordResetSuccessMsg: 'Account {name} password has been reset to songguo123',
  passwordResetTo: 'Account {name} password has been reset to songguo123',
  payStatus: 'Pay Status',
  payStatusLabel: 'Pay Status',
  payStatusNotPaidInFull: 'Not paid in full',
  payStatusReceived: 'Received',
  payStatusUnpaid: 'Unpaid',
  payedTotalAccountAmount: 'Paid Cash Amount',
  payedTotalVoucherAmount: 'Paid Voucher Amount',
  paymentTime: 'Payment Time',
  pending: 'Pending Confirmation',
  pendingConfirm: 'Pending Confirm',
  permissionCheckTip: '*Please check the permissions for this identity in the form below',
  person: 'undefined',
  pineconeOrder: 'Pinecone Order',
  playRecording: 'Play Recording',
  pleaseEnter: 'Please enter the purchase order number',
  pleaseEnterPlain: 'Please enter',
  pleaseEnterAdName: 'undefined',
  pleaseEnterBindMobile: 'Please enter mobile to bind',
  pleaseEnterCorrectMobile: 'Please enter a valid mobile number',
  pleaseEnterEmail: 'Enter email',
  pleaseEnterLoginPassword: 'Please enter login password',
  pleaseEnterMobile: 'Enter mobile for password recovery',
  pleaseEnterMsgTitle: 'Enter message title',
  pleaseEnterName: 'Enter name',
  pleaseEnterOrderNo: 'Enter order no.',
  pleaseEnterProductName: 'Enter product name',
  pleaseEnterPurchaseOrderNo: 'Enter purchase order no.',
  pleaseEnterRemark: 'Enter remark',
  pleaseEnterSchoolName: 'Please enter school name',
    pleaseEnterStudentName: 'Enter student name',
    pleaseEnterStudentPhone: 'Enter student phone',
  pleaseEnterTrueName: 'Please enter real name',
  pleaseEnterVerifyCode: 'Please enter verification code',
  pleaseFillExpressNo: 'Please fill in express no.!',
    pleaseFillMsgDesc: 'Enter message description',
    pleaseFillOrderTimeOrDispatchTime: 'Please fill in order time or dispatch time first',
  pleaseFillPageName: 'Please fill in page name in page settings',
  pleaseFillRoleName: 'Please fill in custom identity name',
    pleaseSelect: 'Please select',
  pleaseSelectAccountStatus: 'Select account status',
  pleaseSelectAccountType: 'Select account type',
  pleaseSelectActivityTimeRange: 'Please select activity start time - end time',
  pleaseSelectAdPosition: 'undefined',
  pleaseSelectAddStudents: 'Please select students to add',
  pleaseSelectAgent: 'Select agent',
  pleaseSelectAgentNo: 'Select agent number',
  pleaseSelectAgentType: 'Select agent type',
  pleaseSelectAnalyst: 'Select analyst',
  pleaseSelectAnalystAccountStatus: 'Select analyst account status',
  pleaseSelectCallSystem: 'Select call system',
  pleaseSelectDisNo: 'Select outbound display mobile',
  pleaseSelectEmployee: 'Select employee',
  pleaseSelectExpressCompany: 'Please select express company',
  pleaseSelectExtNo: 'Select extension number',
  pleaseSelectGender: 'Please select gender',
  pleaseSelectHandover: 'Please select handover person first!',
  pleaseSelectLinkData: 'undefined',
  pleaseSelectMainSystem: 'Please select main system first',
  pleaseSelectMonth: 'Select month',
    pleaseSelectOrderStatus: 'Select order status',
  pleaseSelectOrderType: 'Select order type',
  pleaseSelectOuterDisplayMobile: 'Select outbound display mobile',
    pleaseSelectPayStatus: 'Select pay status',
  pleaseSelectPerson: 'Select person',
  pleaseSelectProductType: 'Select product type',
  pleaseSelectRemoveStudents: 'Please select students to remove',
  pleaseSelectSchoolRegion: 'Please select school province/city/district',
    pleaseSelectStatus: 'Select status',
  pleaseSelectSubject: 'Select subject',
  pleaseSelectSupervisor: 'Select supervisor',
  pleaseSelectSupervisorStatus: 'Select supervisor status',
  pleaseSelectTeachingStage: 'Select teaching stage (multiple)',
  pleaseSelectTeachingSubject: 'Please select teaching subject',
  pleaseSelectUpgradeLevel: 'Please select upgrade level first',
  pleaseSelectWarehouse: 'Select warehouse',
  pleaseSelectYear: 'Select year',
  placeholderSelectMonth: 'Select month',
  monthLabel: 'Month',
  monthNumberLabel: 'M{n}',
  allOption: 'All',
  pleaseUploadFacePhoto: 'Please upload face photo as required',
  pleaseUploadImage: 'Please upload image',
  pointsSuffix: ' pts',
  potentialCustomer: 'Potential customers',
  previewPermission: 'Preview permission',
  price: 'Cash Unit Price',
  priceIncreaseAmount: 'Price Increase Amount',
  productModel: 'Product Model',
  productName: 'Product Name',
  productPrice: 'Product Unit Price',
  productType: 'Product Type',
    province: 'Province',
    provinceActivateExport: 'Province Activate Data Report Export',
  provinceAverage: 'Province Avg',
  provinceCityDistrict: 'Province/City/District',
  provincialPending: 'Provincial scoring pending',
  purchase: 'Purchase Unit Price',
  purchaseAmount: 'Purchase Amount',
  purchaseNum: 'Purchase Qty',
  purchaseOrderNo: 'Purchase Order No.',
  purchaseOrderValueExport: 'Purchase Order Value Report Export',
  purchaseQuantity: 'Purchase Qty',
  purchaseTotalAmount: 'Purchase Total Amount',
  purchaseUnitPrice: 'Unit Price',
  qing: 'Applicant',
  quantity: 'Quantity',
  qudai: 'Regional Agent ID',
  qudaifen: 'Regional Agent Shares Value-added Service Fee',
  qudaifending: 'Regional Agent Shares Subscription Fee Commission',
  queryDate: 'Query Date',
  questionCount: 'Question Count',
  questionMarkRateLabel: 'Question Mark Rate',
  quickConfigTip: 'Select sub-account identity, system will auto-configure permissions',
  quickConfigTip2: '(Can be adjusted manually after configuration)',
  quickIdentity: 'Custom Quick Identity',
  quickSearchAddPermission: 'Quick search to add permission',
  reInvite: 'Re-invite',
  reInviteSuccess: 'Re-invitation sent. Please remind employee to check DingTalk',
  reactivate: 'Reactivate',
  readCircle: 'Read & Circle',
  readCircleCoverageRate: 'Read Circle Coverage Rate',
  readCircleEffectiveRate: 'Read Circle Effective Rate',
  readCircleHelp: 'How to do read & circle well?',
  reapply: 'Reapply',
  receiveAddress: 'Receive Address',
  receiveByName: 'Receiver',
  recentThreeScores: 'Recent Three Scores',
  rechargeTime: 'Recharge Time',
  referralContractAmount: 'Referral Contract Amount',
  referralCustomerId: 'Referral Customer ID',
  referralCustomerName: 'Referral Customer Name',
  regionAgentId: 'Region Agent ID',
  regionShareSubscriptionRebate: 'Region Share Subscription Rebate',
  regionShareValueAddedFee: 'Region Share Value-added Fee',
  rejected: 'Rejected',
  release: 'Release',
  remark: 'Remark',
  remove: 'Remove',
  removeFail: 'Remove failed',
  removeFailed: 'Remove failed',
  removeSuccess: 'Remove successful',
    renew: 'Renew',
    renewSuccess: 'Renewed successfully',
  experienceRenewConfirmTip: 'Renewal can only be done for one year at a time. After submission, the employee learning account of {name} will be renewed for the subscription period. Please make sure the employee uses it properly. Continue?',
  replenishmentTime: 'Replenishment Time',
  requestFailRetry: 'Request failed, please try again later',
  resendAfter: 'Resend in {count}s',
  resetFailed: 'Reset failed',
  resetPassword: 'Reset Password',
  resetPasswordAfterTip: 'After reset, password will be initial password [songguo123]',
  resetPasswordConfirm: 'Reset login password for account',
  resetPasswordTip: 'undefined',
  resetPasswordTitle: 'Reset Password',
  resetSuccess: 'Reset successfully',
  resign: 'Resign',
  resignAssetTip: 'This employee account has the following assets. Please choose to release or hand over',
  resignConfirmTip: 'After resignation is submitted, the data associated with {mobile} of {name} will be cleared and removed from DingTalk organization. This action cannot be undone. Confirm to continue?',
  resignFailed: 'Resignation failed',
  resignOperation: 'Resignation operation: ',
  resignRecord: 'Resignation record',
  resignSuccess: 'Resignation successful',
  resignSuccessTip: 'After resignation, the employee account will be removed from ID{campusId} and cannot be recovered',
  resigned: 'Resigned',
    responsibleSupervisor: 'Responsible Supervisor',
  restart: 'Restart',
  returnBackPayValue: 'Return Back Pay',
  rewardAmount: 'Reward Amount',
  rewardRate: 'Reward Rate',
  sampleAccount: 'Sample Account',
  san: 'Level 3',
  save: 'Save',
  saveFailed: 'Save failed',
  saveSuccess: 'Saved successfully',
  schoolDataBase: 'Data Library',
  schoolYear: 'School Year',
  score: 'Score',
  scoreCollectRate: 'Score Collection Rate',
  scoreCollected: 'Score Collection (Total)',
  scoreImprovementRate: 'Score Improvement Rate',
    scoreLabel: 'Score',
  scoreManage: 'Score Management',
    scoreRule1Basis: 'Based on: average weekly study duration per supervised student',
    scoreRule1Text1: 'Regular term: 6h/week avg = 10 pts',
    scoreRule1Text2: 'Holiday: 20h/week avg = 10 pts',
    scoreRule1Text3: 'Monthly score = avg of all weekly scores',
  scoreRule1Title: '1. Study Duration',
    scoreRule2Basis: 'Based on: high-activity ratio of supervised students',
    scoreRule2Text1: 'vs national avg: +10% = +1 pt, -10% = -1 pt',
    scoreRule2Text2: 'Monthly score = avg of all weekly scores',
  scoreRule2Title: '2. High Activity',
    scoreRule3Basis: 'Based on: study process anomalies',
    scoreRule3Text1: '10 base pts per student per week, deductions for anomalies',
    scoreRule3Text2: 'Different anomaly levels, different deductions by season',
    scoreRule3Text3: 'Weekly score = avg of supervised students',
    scoreRule3Text4: 'Monthly score = avg of all weekly scores',
  scoreRule3Title: '3. Study Process Anomaly',
    scoreRule4Basis: 'Based on: supervisor process trace rate',
    scoreRule4Text: 'Score = trace rate avg × 10',
  scoreRule4Title: '4. Study Trace',
    scoreRule5Basis: 'Based on: 3-month service retention',
    scoreRule5Text1: 'Score = 3-month retention × 10',
    scoreRule5Text2: 'Note: New supervisors (<3 months) excluded',
  scoreRule5Title: '5. 3-Month Service Retention',
  scoreRuleTotalDesc: 'Total score (max 10) is determined by 5 dimensions.',
  search: 'Search Analyst:',
  searchAnalyst: 'Search Analyst:',
  secmin: 'Seconds to Minutes',
  securityVerification: 'Security Verification',
  selectEmployee: 'Select Employee:',
  selectMainSystem: 'Select main system',
  selectRolePermission: 'Select role permission',
  selfProcessExplain: 'Self Process Explanation',
  selfScoreLabel: 'Self Score',
  selfStudyNum: 'Self-study Room Students',
  send: 'Send',
  sendFail: 'Send failed',
  sendSuccess: 'Sent successfully',
  serviceCenterAllStudents: 'All students in service center',
  serviceRetentionRate: 'Service Retention Rate',
  serviceRetentionRateTip: '3-month retention: Of students transferred 3 months ago, what % are still in this center with ≥4h monthly study. Same logic for 6/9/12 months.',
  serviceTeacher: 'Supervisor',
  settlementMonth: 'Settlement Month',
  shi: 'Tens place',
  shu: 'Reward Coefficient',
  sixMonthRetentionRate: '6-Month Retention Rate',
  sixMonths: '6 Months',
  skipVideo: 'Skip Video',
  snCode: 'Device SN',
  softwareActivateTime: 'Software Activate Time',
  softwareActiveMonth: 'Software Active Month',
  softwareActiveStatus: 'Software Active Status',
  splitUser: 'Split User',
  splittingTime: 'Splitting Time',
  springTerm: 'Spring',
  squirrelOrder: 'Squirrel Order',
  stageGrade: 'Stage/Grade',
  statsPeriodLabel: 'Stats Period',
  status: 'Analytics System Account Status',
  student: 'Student',
  studentAccount: 'Student Account',
  studentData: 'Student Data',
  studentInfoIncomplete: 'Student info incomplete, cannot remove',
  studentManage: 'Student Management',
  studentNameLabel: 'Student Name',
  studentPhoneLabel: 'Student Phone',
  studentsCount: ' students',
  studentsOfTeacher: 'Students of {name}',
  studyAbnormal: 'Study Process Anomaly',
  studyAbnormalHelp: 'What to do when study process has anomalies?',
  studyAbnormalOverview: 'Study Abnormal Overview',
  studyAbnormalScene: 'Study abnormal scene',
  studyAccuracy: 'Study accuracy',
  studyDuration: 'Study Duration',
  studyMonitorAlert: 'Study monitor alert',
  studyTrace: 'Study Trace',
  subject: 'Subject',
  subjectLabel: 'Subject',
  submit: 'Submit',
  submitFailed: 'Submit failed',
  submitScoreNum: 'Score Submission Students',
  submitSuccess: 'Submit successful',
  submitTwiceNum: 'Students with Two Submissions',
  subscribeSubject: 'Subscribe Subject',
  subscriptionFeeAmount: 'Subscription Fee Amount',
  subscriptionFeeRebate: 'Subscription Fee Rebate',
  subsequentError: 'Subsequent Error',
  summaryFillCount: 'Summary Fill Count',
  superviseStudent: 'Supervised students',
  supervising: 'Supervising',
  supervisor: 'Supervisor:',
  supervisorColon: 'Supervisor: ',
  supervisorData: 'Supervisor Data',
  supervisorLabel: 'Supervisor:',
  supervisorManage: 'Supervisor Management',
  supervisorName: 'Supervisor Name',
  supervisorNoData: '{names} and {count} supervisor(s) have no data',
  supervisorStatus: 'Supervisor Status',
  supervisorStudents: 'supervised students',
  supervisorSummaryCoverageTip: 'Supervisor summary coverage: ratio of students with ≥50min single-subject study per week who filled supervisor summary',
  supervisorSummaryFillRate: 'Summary Fill Rate',
  supervisorSummaryLabel: 'Supervisor Summary',
  supervisorSummaryWeek1: 'Supervisor summary coverage, Week 1',
  supervisorSummaryWeek2: 'Supervisor summary coverage, Week 2',
  supervisorSummaryWeek3: 'Supervisor summary coverage, Week 3',
  supervisorSummaryWeek4: 'Supervisor summary coverage, Week 4',
  supervisorSummaryWeek5: 'Supervisor summary coverage, Week 5',
  studentSummaryFillRate: 'Supervisor Summary Fill Rate',
  supervisorValidUntil: 'Supervisor Valid Until',
  supplementReward: 'Supplement',
  teacher: 'Analyst',
  teacherManage: 'Analyst Management',
  teacherManagement: 'Analyst Management',
  teacherNameLabel: 'Supervisor Name',
  teacherScoreManage: 'Supervisor Score Management',
  teachingStage: 'Teaching Stage',
  teachingSubject: 'Teaching Subject',
  tenPoints: '10 pts',
  term: 'Term',
  text0gz9: 'Extract Different Items',
  text0mll: 'If the current position is',
  text0tr2: 'or the search criteria have changed',
  text0w3u: 'Draft Writing Accuracy',
  text0w9z: 'Supervisor Process',
  text0x15: 'All set to defaults',
  text17ch: 'Supervisor Data',
  text1926: 'Check if it is a valid number',
  text2vs2: 'and the answer is incorrect',
  text39f7: 'Use slots for custom display',
  text3mvs: 'Get all supervisors',
  text3pv9: 'Convert to numeric type',
  text3u4k: 'Service Retention Rate',
  text3xl2: 'Processing',
  text40ep: 'Structure',
  text489f: 'Answering too slowly',
  text48yo: 'Answering too slowly and incorrect',
  text49aa: 'Draft Step Writing Rate',
  text4h9c: 'Answered incorrectly',
  text4t75: 'Question reading & marking status',
  text627i: 'Single week',
  text6g6k: 'Example trial passing rate',
  text6ntj: 'Then',
  text7141: 'Done',
  text76xd: 'Use',
  text78b4: "If the trial is wrong, watching the video won't help",
  text7hj4: 'Instead of',
  text82nx: 'Severity',
  text8f95: 'Play music',
  text8mo7: 'Task card',
  text8ocs: 'Display as',
  text9437: 'Please select a supervisor',
  text99pk: 'Tag stop-play event',
  text9fgp: 'Custom display via named slots',
  text9g2t: 'Number of example trial attempts',
  text9rrm: 'Register a global event listener',
  text9vdz: 'For child components to get supervisor data',
  text9ymf: 'Weekly data',
  texta01x: 'Out of the total number of questions',
  texta4yg: 'or not played',
  texta9jk: 'Knowledge points',
  textafry: 'Other modules import and use directly',
  textah6t: 'For comparison',
  textaj3b: 'Needs to be added',
  textas1f: 'Not focused',
  textatdj: 'Compare two arrays',
  textb13r: 'Custom contact name',
  textb1td: 'Destroy subscription',
  textb3iv: 'Convert data format',
  textb42m: 'Exception level & severity table configuration',
  textb57b: 'Exceeds in a single week',
  textb9f4: 'Supervisor',
  textbnko: 'Supervisor result',
  textbw1c: 'Use slot type',
  textc6ge: 'Supervisor growth',
  textcbtu: 'Trial-and-error result',
  textclml: 'Or click Search after manually clearing',
  textd04f: 'Learning accuracy',
  textdbku: 'Number of questions answered too slowly/too quickly and incorrectly',
  texte5xq: 'Requires special handling',
  texte71e: 'Exception level',
  textehfn: 'Accuracy for unanswered draft-writing questions',
  texteoqz: 'Playback ended',
  textfri7: 'Leave the learning interface',
  textg9jw: 'Not qualified',
  textg9lu: 'Overall accuracy',
  textg9q3: 'Example trial tracking rate',
  textgq8m: 'Draft passing rate',
  texthcky: 'Remove event listener',
  texthhgq: 'StudentData',
  texthmgc: 'Consecutive incorrect',
  texthvgt: 'High activity rate',
  texthyxj: 'Skip video and answer incorrectly',
  texti83z: 'Exceeds',
  texticoe: 'Listening',
  textif5e: 'Playback progress',
  textiixp: 'Easier to process digit by digit',
  textio06: 'Process data',
  textiqb0: 'Question answer is incorrect',
  textj0nj: 'Spot-check question practice evaluation',
  textj25c: 'Supervisor Data Table Title',
  textj3ol: 'Not done',
  textj5rx: 'Click',
  textj9q6: 'Supervisor Name',
  textjml8: 'Total number of questions',
  textjo43: 'Incorrect answers for subsequent questions',
  textkm2l: 'Can start the playback event',
  textkoo8: 'Ones digit',
  textl7dp: 'and accuracy',
  textlmp2: 'Low example trial rate',
  textlysd: 'Alert condition',
  textmgeu: 'Supervisor Data Table Data',
  textmj7g: 'Draft step-writing status',
  textml6j: 'Position from right to left',
  textmvg4: 'Add numbers and units',
  textmxwo: 'Pause event for the tag',
  textn2me: 'No data for the supervisor yet',
  textn6iq: 'Get the playback position',
  textn73g: 'Course level',
  textnbar: 'Cached data',
  textneeb: 'Pass',
  textnz99: 'Convert the array structure to',
  textoida: 'Video example trial status',
  textoros: 'Update the current component\'s',
  textot2j: 'Audio-loaded event for the tag',
  textowbi: 'Low draft writing rate',
  textp2cw: 'Convert number to string',
  textp3v5: 'So this must be set to',
  textpi0u: 'Question reading & marking tracking rate',
  textpq4z: 'Trial correct',
  textpr2f: 'Number of draft step writings',
  textpruy: 'Daydreaming',
  textq0ee: 'Compare with all supervisor list',
  textqp4o: 'Video',
  textr44b: 'Original panel',
  textrcak: 'Spring and Autumn',
  textrfhl: 'Knowledge point notes',
  textri2f: 'Answering too quickly',
  textrqvd: 'Learning status is offline',
  textsp46: 'Skip video',
  textt2sn: 'High activity rate',
  textt9gm: 'Streak',
  texttcnp: 'Service Retention Rate',
  textte0m: 'Basic numeric mapping',
  texttsu0: 'Trigger conditions',
  textu6da: 'Total supervisor data table records',
  textujf7: 'Playback status',
  textuom8: 'If trial practice is wrong, watching the video will help',
  textup01: 'Draft tracking rate',
  textv7bp: 'Learning process monitoring alarm table configuration',
  textv7f9: 'Wait until the audio finishes loading',
  textvbft: 'Seasons',
  textw0yx: 'Skip video and get it wrong',
  textw70q: 'Example trial rate',
  textw887: 'Questions done',
  textwfar: 'Total number of videos',
  textwnem: 'Click the clear button',
  textwnfr: 'Triggers an abnormal scenario within the week',
  textxq0a: 'The answers in the question are incorrect',
  textxus0: 'Leave mid-session',
  textxw4v: 'Otherwise should be defaults',
  texty2le: 'and the accuracy of unanswered draft questions',
  texty46b: 'Playback recording',
  texty6ox: 'New student management',
  textyiin: 'Supervisor data',
  textyk6y: 'Drag panel progress bar',
  textylh1: 'Processing can start playback event',
  textynd0: 'Draft passing rate',
  textypuv: 'All questions are done',
  textys7i: 'Random answering',
  textz0mj: 'Handle special cases',
  textzgl8: 'Answered too quickly and wrong',
  textzmi8: 'Format',
  textznuz: 'Knowledge point notes tracking rate',
  textzpjo: 'Only query active teachers',
  textzrhn: 'Mapping',
  textzt6o: 'Summary Fill Rate',
  textzun2: 'Can not study',
  thisMonthHighActiveRate: 'This Month High Active Rate',
  threeMonthRetention: '3-Month Retention',
  threeMonthRetentionRate: '3-Month Retention Rate',
  threeMonths: '3 Months',
  time: 'Time',
  times: 'Times',
  timesDesc: 'Times description',
  tizhanghu: 'Voucher account',
  totalAccountAmount: 'Cash Amount (incl. voucher)',
  totalCorrectRate: 'Overall correct rate',
  totalErrorCount: 'Total Error Count',
  totalLearnTime: 'Total Learn Time',
  totalPrice: 'Total Price',
  totalReturnedAmount: 'Total Returned Amount',
  totalScore: 'Total Score',
  totalScoreLabel: 'Total Score',
  totalStudyDuration: 'Total Study Duration',
  totalVoucherAmount: 'Voucher Amount',
  transferCampusId: 'Transfer Agent ID',
  transferCampusName: 'Transfer Agent Name',
  trialAccount: 'Trial Account',
  trialDate: 'Trial date',
  trialErrorKnowledge: 'Trial error knowledge',
  trialErrorResult: 'Trial error result',
  trialErrorWatchVideoNotOk: 'Trial error, watched video, not understood',
  trialErrorWatchVideoOk: 'Trial error, watched video, understood',
  trialStillNotOkSuffix: ' videos after trial still not understood, please pay attention',
  trialStillNotOkTip: ', ',
  twelveMonthRetentionRate: '12-Month Retention Rate',
  twelveMonths: '12 Months',
  type: 'Account Type',
  unit: 'undefined',
  updateFaceInfo: 'Update Face Info',
  updateTime: 'Update Time',
  uploadFail: 'Upload failed',
    uploadSizeExceed1MB: 'Upload file size cannot exceed 1MB',
    uploadSuccess: 'Upload successful',
  uploadedImages: 'Uploaded Images',
  userName: 'Username',
  valueAddedServiceFee: 'Value-added Service Fee',
  verifyCode: 'Verification code:',
  verifyFailed: 'Verification failed!',
  verifySuccess: 'Verification successful!',
  view: 'View',
  viewAccountPassword: 'View Account Password',
  viewAll: 'View All >',
  viewDetail: 'View Detail',
    viewFail: 'View failed',
  viewImage: 'View Image',
  viewStudent: 'View Students',
  viewStudentLabel: 'View Student',
  viewSummary: 'View Summary',
  viewTrialErrorKnowledge: 'View trial error knowledge',
  voucherPrice: 'Voucher Unit Price',
  vsLastMonth: 'vs Last Month',
  wake: 'Wake',
  wakeConfirmTip: 'After account is woken up, {username}',
  wakeFailed: 'Failed to wake account',
  wakeSuccess: 'Account woken up successfully',
  warehouse: 'Warehouse',
  week: 'Statistics period',
  weekAlarmCount: 'Weekly alarm count',
  weekEndDate: 'Week (End Date)',
  weekErrorAnalysisRate: 'Weekly grade 1-6 error analysis completion rate',
  weekTrialRatio: 'Weekly example trial rate',
  weight: 'Weight',
  weight25: '25%',
  weightNewOld: '25% (new) / 25% (existing)',
  weightRetention: '0% (new) / 10% (existing)',
  withdraw: 'Withdrawal Account',
  within10Chars: 'Within 10 characters',
  within30Chars: 'Within 30 characters',
  wrongAndNotOk: 'Wrong, still not understood',
  wrongAndOk: 'Wrong, understood',
  wu: 'Invalid',
  year: 'Year',
  yearSuffix: '',
  yes: 'Reward sent?',
  yi: 'Level 1',
  yihour: 'Duration per question',
  yishi: 'Ten',
  yixunCallSystem: 'Yixun Call System',
  yong: 'Disable',
  yonge: 'Available Quota',
  you: 'Valid',
  youqi: 'Validity period',
  zhanghu: 'Fission Account',
  actualAmount: 'Actual Amount',
  export: 'Export',
  hao: 'Purchase order number',
  text0o0d: 'Purchase quantity',
  text23z5: 'Manufacturer shipment management',
  text2b7i: 'Cash account',
  text3m5o: 'Import details',
  text8kdk: 'Fission bonus account',
  text8ojn: 'ImportDetailsList',
  textb2w1: 'Or click Search after manually clearing',
  textbsxw: 'Click the clear button',
  textc66c: 'Download import results',
  textffcb: 'Voucher account',
  textfkn9: 'Then',
  texthgq2: 'Account balance',
  texti0u5: 'Imported',
  textj87y: 'Purchase amount',
  textke1h: 'Unsubscribe',
  textkf9v: 'ImportType',
  textkh28: 'Gold account',
  textm22h: 'Otherwise should be defaults',
  textn0ux: 'Maximum deductible',
  textose4: 'All are set to default',
  textspvo: 'Available amount',
  textuuw6: 'Total data amount',
  textvla9: 'Table data query',
  textym5z: 'Or search criteria have changed',
  textzx8x: 'Not imported',
  auto_114_bf5738cf: 'Label',
  auto_115_54bf2acb: 'Label',
  auto_116_6ce2c91b: 'Label',
  auto_117_5a0eda5e: 'Label',
  auto_118_c996d044: 'Label',
  auto_119_47f91cb3: 'Allti zuo le',
  auto_120_87db356c: 'Label',
  auto_121_dac8b361: 'Label',
  auto_122_6d225d37: 'Label',
  auto_123_b8340646: 'Label',
  auto_124_13c6e860: 'Label',
  auto_125_b455aa66: 'Level 1',
  auto_126_52e5e119: 'Level 2',
  auto_127_601a8062: 'Label',
  auto_128_9f36d418: 'Level 3',
  auto_129_5823f537: 'Label',
  auto_130_82661969: 'xue xiStatusbu zai xian',
  auto_131_c2c2e569: 'dan ri xue xiDazehuo zhong tu li',
  auto_132_ab17e28a: 'Label',
  auto_133_435003ac: 'dan riConsecutive ErrorTimesci',
  auto_134_39dc31a3: 'Label',
  auto_135_c36ab2f9: 'dan ri xue xiAnswer Fastde ti',
  auto_136_9b4acfbb: 'Label',
  auto_137_e0addb98: 'dan ri xue xiAnswer Slowde ti',
  auto_138_44b28708: 'duo ciSkip Videozuo cuo',
  auto_139_6ca2cf8a: 'dan ri xue xiSkip Videoqie hou xu',
  auto_140_05a4538b: 'Label',
  auto_141_19e584cd: 'dan ri cao gao shu xie lvLower Thanqie',
  auto_142_599c751f: 'Example Trial Ratedi',
  auto_143_f7e255db: 'dan riExample Trial Rate',
  auto_144_6ce6fdb2: 'Error Analysis Ratedi',
  auto_145_82ea5516: 'dan zhou jiError Analysis Rate',
  auto_146_34ea6de7: 'Study Durationguo di',
  auto_147_0ddc1e9b: 'dan zhouStudy Durationchun qiuh',
  auto_148_8be52cf5: 'Daze',
  auto_149_e1cbdb93: 'chao guominting liu yuan ye mian wu',
  auto_150_3a20f613: 'Leave Midway',
  auto_151_5adffc36: 'Label',
  auto_152_19f7a463: 'Consecutive Error',
  auto_153_3771d346: 'Consecutive Errorti da an bu zheng que',
  auto_154_86a7f26f: 'Answer Slowqie zuo cuo',
  auto_155_5c563bec: 'Label',
  auto_156_4a5bd9d8: 'Answer Fastqie zuo cuo',
  auto_157_4fa255ac: 'Skip Videoqie zuo cuo',
  auto_158_b950ac31: 'DazeTimesLeave MidwayTimes',
  auto_159_19fcd54d: 'xue xiStatusbu zai xian',
  auto_160_11540b79: 'Label',
  auto_161_cdda286b: 'Label',
  auto_162_73c63a4c: 'Label',
  auto_163_4706dfb4: 'tiao guoVideoqie cuo',
  auto_164_5eb2cb24: 'Label',
  auto_165_32b092a6: 'Example Trial Ratedi',
  auto_166_bb0dec1c: 'Error Analysis Ratedi',
  auto_167_7c265b59: 'Study Durationguo di',
  auto_168_d53fd8ce: 'Daze',
  auto_169_dfaf2fe9: 'Leave Midway',
  auto_170_694677ae: 'Consecutive Error',
  auto_171_197284ff: 'Answer Fast',
  auto_172_9ce33983: 'Answer Slow',
  auto_173_2a8aa150: 'Skip Video',
  auto_9_7702c220: 'videos still wrong after watching, please follow up',
  auto_10_94d8dc85: 'Operation',
  auto_72_200c7f02: 'zhouTotal',
  auto_73_1aa0cbc1: 'Question Count',
  auto_74_f371ad39: 'Label',
  auto_75_f461c84a: 'Label',
  auto_76_32e0744f: 'Label',
  auto_77_ca6e3a94: 'Label',
  auto_78_17d9fd5b: 'Label',
  auto_79_fec0a1ff: 'Label',
  auto_80_b56f5e7f: 'Other',
  auto_81_e848b086: 'Label',
  auto_82_50b93981: 'Label',
  auto_83_57aa31d8: 'Label',
  auto_84_a073d31c: 'Label',
  auto_85_8e0080c1: 'Label',
  auto_86_0e2944a3: 'Label',
  auto_87_d62a1027: 'Label',
  auto_88_d6d18239: 'Label',
  auto_89_91107ea9: 'Label',
  auto_90_bfb825f6: 'Label',
  auto_91_398b2be6: 'Label',
  auto_92_923a6343: 'Label',
  auto_93_167b0d71: 'Label',
  auto_94_85c18c37: 'Label',
  auto_95_1f14b816: 'Label',
  auto_96_fd486a7b: 'Label',
  auto_97_3ac813a4: 'Label',
  auto_98_c51048bb: 'Label',
  auto_99_68c14998: 'Daze',
  auto_100_f163cf3e: 'Leave Midway',
  auto_101_d583cfee: 'Consecutive Error',
  auto_102_c7481dd3: 'Answer Slow',
  auto_103_ea985fd9: 'Answer Fast',
  auto_104_4bfe4284: 'Skip Video',
  auto_105_57d57fcb: 'zhouTotal',
  auto_106_2761a940: 'zhouTotal',
  auto_107_f5812327: 'zhouTotal',
  auto_108_59fb5aa1: 'Label',
  auto_109_cbfa7f73: 'Label',
  auto_110_a746491a: 'Label',
  auto_111_543c525a: 'Label',
  auto_112_8c6b4fd7: 'This Weekchao guo ci',
  auto_113_85b7ea72: 'Label',
  auto_1_92ac947e: 'facePhotoSpec',
  auto_1_af831ca6: 'internalAccountTip',
  auto_2_8680ff0e: 'facePhotoSpec',
  auto_2_cdaf92ef: 'internalAccountTip',
  auto_3_492f529f: 'facePhotoSpec',
  auto_5_6926543b: 'Renew',
  auto_6_dcb6f800: 'Label',
  auto_46_0269e1a7: 'Name',
  auto_47_2c563fe1: 'Phone Number',
  auto_48_25b1635b: 'Employee Account Status',
  auto_49_67388bbd: 'Learning Account Status',
  auto_50_8c579ca9: 'Face Info Status',
  auto_51_ecb0aad5: 'Account',
  auto_52_623e4ad2: 'Password',
  auto_53_865532f4: 'Claim Time',
  auto_54_9872669f: 'Claim User',
  auto_55_a0aaef39: 'Total Learn Time',
  auto_56_9da20d34: 'Effective Foundation Time',
  auto_57_4404a352: 'Label',
  auto_58_d137d18a: 'Label',
  auto_59_57b30a83: 'Staff Name',
  auto_60_d8558a9f: 'Label',
  auto_61_bfa0d9bd: 'Selectyuan gong',
  auto_62_acd6af11: 'Label',
  auto_63_45ee5864: 'Label',
  auto_64_9b6a6432: 'Staff Name',
  auto_65_12e98425: 'Label',
  auto_66_e952fd8b: 'Staff Name',
  auto_67_cc2666cb: 'zhao pian bing fei cheng ren shi fouConfirm',
  auto_68_1eda70cf: 'Tip',
  auto_69_e81d7d59: 'Confirm',
  auto_70_900ca9ea: 'Cancel',
  auto_71_f97bdd1c: 'zhi nengUploadge shi deImage',
  auto_2_8ca8fe3a: 'Note: To modify employee mobile number, please ask the employee to log in and go to Account Security Center after account activation',
  auto_3_185fe505: 'Dealer system',
  auto_4_5a97edcd: 'Label',
  auto_17_bf9a90f1: 'Hantian Traffic System',
  auto_18_1ad7b8b4: 'Hantian Traffic System',
  auto_19_1d37d402: 'Yixun Traffic System',
  auto_20_26847597: 'Yixun Traffic System',
  auto_21_171a6e64: 'Hantian Traffic System',
  auto_22_25772312: 'Label',
  auto_23_8a044272: 'Hantian Traffic System',
  auto_24_551e9c46: 'Yixun Traffic System',
  auto_25_a4b78e20: 'Hantian Traffic System',
  auto_26_83f5dffb: 'Yixun Traffic System',
  auto_27_89da19db: 'Hantian Traffic System',
  auto_28_1c224ce0: 'Yixun Traffic System',
  auto_29_6fed4f90: 'Hantian Traffic System',
  auto_30_0f3124fe: 'Yixun Traffic System',
  auto_31_767a0f0a: 'Hantian Traffic System',
  auto_32_712e9572: 'Hantian Traffic System',
  auto_33_6ba38b4a: 'Label',
  auto_186_ec018485: 'All',
  auto_187_52b1e87b: 'New Student Name',
  auto_188_59607ccf: 'New Student Period',
  auto_189_317f9f06: 'Responsible Supervisor',
  auto_190_c6404dc3: 'Total Study Duration',
  auto_191_b98e5332: 'Question Mark Rate',
  auto_192_1f1d4f0a: 'Draft Writing',
  auto_193_027dea62: 'Example Trial',
  auto_194_c09bf149: 'Error Analysis',
  auto_195_b76e8428: 'Self Process Explanation',
  auto_196_17bc2fdf: 'First Week Feedback',
  auto_197_e981487a: 'Instinct Level Explanation',
  auto_198_4803b6e8: 'Health Level Explanation',
  auto_199_ed031edd: 'Recent Three Scores',
  auto_208_03332d86: 'No data',
  auto_209_c2ddbe66: 'Score Collection Rate',
  auto_210_0e770f18: 'shou jiScoreshu',
  auto_211_08833df5: 'SupervisorStudent',
  auto_212_99ec8ae3: 'Effective Score Rate',
  auto_213_735a30c2: 'ValidScoreshu',
  auto_214_ca729786: 'SupervisorStudent',
  auto_215_6018038c: 'Exam Score Improvement Rate',
  auto_216_d5526d42: 'Improved Score Students',
  auto_217_1af8b376: 'Submitliang ciScoreSupervisorStudent',
  auto_218_e74b5add: 'Autumn',
  auto_219_331c0d4a: 'Spring',
  auto_220_58b31698: 'Midtermshi',
  auto_221_100dfbd5: 'Finalshi',
  auto_230_6776c21f: 'No data',
  auto_231_13483fef: 'Score Collection Rate',
  auto_232_50e70984: 'shou jiScoreshu',
  auto_233_3d44a397: 'SupervisorStudent',
  auto_234_6b5abcc2: 'Effective Score Rate',
  auto_235_83f283e7: 'ValidScoreshu',
  auto_236_0b37fa51: 'SupervisorStudent',
  auto_237_63eee629: 'Exam Score Improvement Rate',
  auto_238_fc1aae13: 'Improved Score Students',
  auto_239_55dd988b: 'Submitliang ciScoreSupervisorStudent',
  auto_240_9a60e0ea: 'Autumn',
  auto_241_7bdfad88: 'Spring',
  auto_242_79576c05: 'Midtermshi',
  auto_243_77e933f3: 'Finalshi',
  auto_12_0a666e12: 'Export',
  auto_34_4bac84df: 'Name',
  auto_35_b2bf97cf: 'Name',
  auto_36_b99b6c5e: 'Leave Date',
  auto_37_f5c5a2ff: 'Name',
  auto_38_6cdce436: 'Phone Number',
  auto_39_a4ff4163: 'Leave Time',
  auto_40_72825acf: 'Operator',
  auto_41_923e5f12: 'Create Time',
  auto_42_12e670c5: 'Potential customers',
  auto_43_f1ef794e: 'qian zaiStudent',
  auto_44_54c4176d: 'Supervised students',
  auto_45_307b3d02: 'Gold coins',
  auto_174_4ca0c639: 'Supervisor',
  auto_175_1e487d14: 'Select supervisor',
  auto_176_e072ae03: 'Year',
  auto_177_549f4edc: 'Select year',
  auto_178_1451d388: 'Supervisor',
  auto_179_a6fe13a2: 'Month',
  auto_180_cc0cd5d6: 'Total Score',
  auto_181_7b6ddcf5: 'Study Duration',
  auto_182_70d25397: 'High Activity',
  auto_183_dd5a5f81: 'Study Process Anomaly',
  auto_184_e239f301: 'Study Trace',
  auto_185_3f249f0b: '3-Month Retention',
  auto_248_97c154c8: 'Hantian Traffic System',
  auto_249_b42d7796: 'Hantian Traffic System',
  auto_250_17c33397: 'Yixun Traffic System',
  auto_251_c1c0bfb5: 'Yixun Traffic System',
  auto_252_0d9a129f: 'Hantian Traffic System',
  auto_253_9ed6b9e2: 'Hantian Traffic System',
  auto_254_1f305749: 'Yixun Traffic System',
  auto_255_6f18d813: 'Hantian Traffic System',
  auto_256_85a71b34: 'Yixun Traffic System',
  auto_257_2a712ab4: 'Hantian Traffic System',
  auto_258_e8ecdf89: 'Hantian Traffic System',
  auto_259_16891ae0: 'Hantian Traffic System',
  auto_260_c0643860: 'Yixun Traffic System',
  auto_261_43a2877f: 'Yixun Traffic System',
  auto_262_fc3c5be0: 'Hantian Traffic System',
  auto_263_60d9d1ff: 'Hantian Traffic System',
  auto_264_265e938b: 'Yixun Traffic System',
  auto_265_e642aeee: 'Hantian Traffic System',
  auto_266_240dd5d6: 'Yixun Traffic System',
  auto_267_009e35da: 'Hantian Traffic System',
  auto_200_cedb377d: 'Midterm',
  auto_201_c72bfc09: 'Final',
  auto_202_7a7919ce: 'Score Collection Rate',
  auto_203_621bd16f: 'Service CenterSupervisorStudy Roomjin',
  auto_204_4bd58f38: 'Effective Score Rate',
  auto_205_9cb80b2f: 'Currentda kaoScorezhong youScore',
  auto_206_3ee43d9c: 'Exam Score Improvement Rate',
  auto_207_a12ebc3f: 'Label',
  auto_222_6d6d75ba: 'Midterm',
  auto_223_2ccf65e2: 'Final',
  auto_224_8d1511b9: 'Score Collection Rate',
  auto_225_ae854796: 'Among supervised students at the service center (study room + online-only), the share who have a major exam score on record.',
  auto_226_6249da25: 'Effective Score Rate',
  auto_227_4c808c87: 'Among supervised students, the share whose current major exam score has supporting documentation.',
  auto_228_c1e58a43: 'Exam Score Improvement Rate',
  auto_229_b037e052: 'Numerator: supervised students whose score on this major exam is higher than on the previous one. | Denominator: supervised students who submitted valid scores for two consecutive major exams.',
  auto_11_1f510f9d: 'Custom Role',
  auto_1_cc870123: 'Label',
  auto_2_0fe929a0: 'Assign Permissions',
  auto_292_27cb13d9: 'Normal',
  auto_13_103986be: 'Export',
  auto_14_3948439b: 'Export',
  auto_15_66896e7e: 'Export',
  auto_16_59bad31d: 'Export',
  auto_17_f2d02b17: 'Export Report',
  auto_18_4d93b56b: 'Export Report',
  auto_19_24b12701: 'Export Report',
  auto_20_84dbc023: 'Export Report',
  auto_21_a73ef1c9: 'Export',
  auto_22_e22d4af4: 'Export Report',
  auto_23_c83fd579: 'Export Report',
  auto_24_f20624c1: 'Export Report',
  auto_25_6ca8b5f2: 'Export Report',
  auto_26_1e9ac54b: 'Export Report',
  auto_27_b9cdcac3: 'Export Report',
  auto_28_7f6fac7f: 'Export Report',
  auto_29_46075933: 'Export Report',
  auto_30_74c980a5: 'Export Report',
  auto_31_4eb86c8d: 'Export Report',
  auto_32_34900b5f: 'Export Report',
  auto_7_b9f5df3b: 'Data Update Time',
  auto_8_a16e1f4a: 'wuImage',
  auto_281_3f293f12: 'Not filled',
  auto_282_fc8617d3: 'wei dao dianSupervisor',
  auto_268_ad79dcb5: 'Supervisor',
  auto_269_179481a8: 'Select supervisor',
  auto_270_be5d6edf: 'Month',
  auto_271_08422b87: 'Select month',
  auto_285_548986fa: 'Midterm',
  auto_286_a09cfab4: 'Final',
  auto_287_bacb05df: 'Subject',
  auto_288_a0ae573b: 'Select subject',
  auto_272_7849a449: 'Supervisor',
  auto_273_016ee162: 'Select supervisor',
  auto_274_866d6785: 'Month',
  auto_275_bb78fd4d: 'Select month',
  auto_276_cbfd49b4: 'Supervisor',
  auto_277_0a55bb3c: 'Select supervisor',
  auto_278_343826d3: 'Month',
  auto_279_6a7d3c7b: 'Select month',
  auto_289_35cc9d39: 'Supervisor',
  auto_290_6b7066bf: 'Select supervisor',
  auto_291_65a1cd2a: 'Service Retention Rate & High Activity Rate',
  auto_283_43133031: 'Completed',
  auto_284_56ca29d8: 'All',
  auto_244_74f9687b: 'Mathematics',
  auto_245_2d033ec9: 'English',
  auto_246_b3637dcf: 'Physics',
  auto_247_1e45c663: 'Chemistry',
  auto_280_a644deaf: 'Label',
  auto_293_8396209e: 'Midterm',
  auto_294_b254bd84: 'Final',
  supervisorStatusFormat: 'Supervisor Status: Study Room ({selfStudy}), Online Only ({onlineOnly})',
  timeRangeOctNov: 'Oct~Nov',
  timeRangeAprMay: 'Apr~May',
  timeRangeJanFeb: 'Jan~Feb',
  timeRangeJunJul: 'Jun~Jul',
  dateFormatYMD: '{month}/{day}/{year}',
  exceptionSeveritySingle: 'Single day/week trigger exception scenario',
  alarmTriggerCondition5: '3 consecutive questions, each answer time < 1/3 of average, and incorrect answers in 3 questions',
  alarmTriggerCondition6: 'Video effective play duration < 1/3 of video or not played, subsequent questions wrong',
  ordOne: '1',
  ordTwo: '2',
  ordThree: '3',
  ordFour: '4',
  ordFive: '5',
  ordSix: '6',
  ordSeven: '7',
  ordEight: '8',
  ordNine: '9',
  ordTen: '10',
  minuteUnit: 'min',
  secondUnit: 's',
  courseLevelUnit: '',
  courseBatchUnit: '',
  ordPrefix: '',
  timesUnit: '',
  hasPrefix: ', has ',
};
